









import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { Settings } from 'luxon';
import Vue from 'vue';

Settings.defaultLocale = 'es';

export default Vue.extend({
  name: 'DateTime',
  components: {
    Datetime,
  },
  props: {
    default: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: '',
    };
  },
  mounted() {
    if (this.default !== '') {
      this.$data.value = this.default;
    }
  },
  watch: {
    value(val: string) {
      this.$emit('input', val);
    },
  },
});
